import React from "react";
import { useTheme } from "styled-components";
import { Emoji } from "emoji-mart";

import Icon, { getIconType } from "../../../../components/ui/icon/Icon";
import {
  SpacerAndDividerContainer,
  SpacerAndDividerContentContainer,
  SpacerAndDividerIconContainer,
  SpacerAndDividerLine,
  SpacerAndDividerSpan,
} from "./styles";
import {
  SPACER_AND_DIVIDER_PROP,
  SPACER_AND_DIVIDER_TYPE,
} from "../../../../optics/components/drawers/settings/features/spacer-and-divider/defaults";

const SpacerAndDivider = ({ data }) => {
  const theme = useTheme();

  const iconType = getIconType(data.dividerIcon);

  const showIcon =
    data[SPACER_AND_DIVIDER_PROP.DIVIDER_TYPE] ===
      SPACER_AND_DIVIDER_TYPE.ONLY_ICON ||
    data[SPACER_AND_DIVIDER_PROP.DIVIDER_TYPE] ===
      SPACER_AND_DIVIDER_TYPE.TEXT_WITH_ICON;

  const showText =
    data[SPACER_AND_DIVIDER_PROP.DIVIDER_TYPE] ===
      SPACER_AND_DIVIDER_TYPE.TEXT ||
    data[SPACER_AND_DIVIDER_PROP.DIVIDER_TYPE] ===
      SPACER_AND_DIVIDER_TYPE.TEXT_WITH_ICON;

  return (
    <SpacerAndDividerContainer
      width={data.width}
      hasContent={showText || showIcon}
    >
      {data.textAlignment !== "left" && (
        <SpacerAndDividerLine
          backgroundColor={data.color[theme.name]}
          height={data.weight}
        />
      )}

      <SpacerAndDividerContentContainer>
        {showIcon && (
          <SpacerAndDividerIconContainer
            size={data.iconSize}
            color={data.color[theme.name]}
          >
            {data.emojiEnabled && !!Object.keys(data.emoji).length ? (
              <Emoji emoji={data.emoji} size={`${data.iconSize}px`} />
            ) : (
              <>
                {iconType === "app" ? (
                  <img
                    src={data.dividerIcon}
                    height={data.iconSize}
                    alt="img"
                  />
                ) : (
                  <Icon icon={data.dividerIcon} size={`${data.iconSize}px`} />
                )}
              </>
            )}
          </SpacerAndDividerIconContainer>
        )}

        {showText && (
          <SpacerAndDividerSpan fontSize={data.fontSize}>
            {data.text}
          </SpacerAndDividerSpan>
        )}
      </SpacerAndDividerContentContainer>

      {data.textAlignment !== "right" && (
        <SpacerAndDividerLine
          backgroundColor={data.color[theme.name]}
          height={data.weight}
        />
      )}
    </SpacerAndDividerContainer>
  );
};

export default SpacerAndDivider;
